import Dfp from "../Dfp";
import PropTypes from "prop-types";
import React from "react";
import {defaultProps} from "./config";


const positions = Object.keys(defaultProps); // 'fisrtLeaderboard', 'firstMediumRectangle', 'loopLeaderboard', 'loopMediumRectangle', 'mobileSplashAd', 'inRead' or 'inPostAd'
const tags = ['nestlemomme', 'nestlebb'];

/**
 * For shemom.com only
 *
 * @see ./index.js
 * The index file should be guiding you how things works.
 */
export default class SheMomContentHubAdvert extends React.PureComponent {

 getAdUnit () {
   const {position, tag} = this.props;
   if (position === 'firstLeaderboard' || position === 'loopLeaderboard') {
     if (tag === 'nesstlemomme') { return "shemom.com_article_NestleMom_970x90"; }
     if (tag === 'nestlebb') { return "shemom.com_article_NestleBB_970x90"; }
   }
   if (position === 'firstMediumRectangle' || position === 'loopMediumRectangle') {
     if (tag === 'nesstlemomme') { return "shemom.com_article_NestleMom_300x250"; }
     if (tag === 'nestlebb') { return "shemom.com_article_NestleBB_300x250"; }
   }
   return null;
 }

 render () {
   const {position, tag, ...restProps} = this.props;
   const adUnit = this.getAdUnit();
   if (!position || adUnit === null) { return null; }
   return (
     <Dfp
       {...defaultProps[position]}
       adUnit={adUnit}
       theme={theme}
       page={page}
       position={position}
       tag={tag}
       {...restProps}
     />
   );
 }
}

SheMomContentHubAdvert.propTypes = {
	callback: PropTypes.func,
	dfpReady: PropTypes.func,
	dfpUpdate: PropTypes.func,
	position: PropTypes.oneOf(positions).isRequired,
  tag: PropTypes.oneOf(tags).isRequired,
};



// WEBPACK FOOTER //
// ./src/Advert/SheMomContentHubAdvert.js